import _ from "lodash";
import { mapActions } from "vuex";

export const multiSelectionMixin = {
  data() {
    return {
      options: {},
      minNumberHPsPerMDU: null,
    };
  },

  methods: {
    ...mapActions([
      "FETCH_ALL_NETWORK_RULES_TEMPLATES"
    ]),

    /**
     * Checks if the given input field is a standard one.
     * @param {String} inputType - type of input field.
     * @return {Boolean}
     */
    isStandardInput(inputType) {
      return (
        inputType === "text" ||
        inputType === "textarea" ||
        inputType === "number" ||
        inputType === "int" ||
        inputType === "email" ||
        inputType === "int_pos"
      );
    },

    /**
     * Gets the exact input type to use if it is a standard one.
     * @param {String} inputType - type of input field.
     * @return {String}
     */
    getSpecificStandardInputType(inputType) {
      if (inputType === "text" || inputType === "comment") {
        return "text";
      } else if (inputType === "number" || inputType === "int" || inputType === "int_pos") {
        return "number";
      } else if (inputType === "email") {
        return inputType;
      }
    },

    /**
     * Checks if the given input field is one that needs the treeselect.
     * @param {String} inputType - type of input field.
     * @return {Boolean}
     */
    isSelectInput(inputType) {
      return inputType === "select" || inputType === "radio";
    },

    /**
     * Gets the original value of a given variable
     * @param {Object} object - object from which the value is being obtained
     * @param {Object} field - field being analysed
     * @return {String | Number}
     */
    getValue(object, field) {
      return _.get(object, field.var_name);
    },

    /**
     * Gets the original value of a given checkbox variable
     * @param object
     * @param field
     * @returns {boolean|String|Number}
     */
    valueCheckboxInObject(object, field) {
      let value = this.getValue(object, field);
      if (value === "1") {
        return true;
      } else if (value === "0") {
        return false;
      } else {
        return value;
      }
    },

    /**
     * Gets the specific list of options needed by a given select field
     * @param {Object} field
     * @returns {Array}
     */
    getSpecificListOfOptions(field, code = null) {
      let listName;
      if (field.input_type === "select") {
        listName = "select_list_name";
      } else listName = "var_name";
      let list = this.options[field[listName]];
      if (list) {
        return code
          ? list.filter(option => !option.isDisabled || option.id === code)
          : list
          ? list.filter(option => !option.isDisabled)
          : null;
      } else {
        return [];
      }
    },

    userNormalizer(node) {
      let userName = node.first_name;
      if (node.last_name) {
        userName += " " + node.last_name;
      }
      return { id: node.id, label: userName };
    },
    /**
     * Determines if a certain select field is clearable or not
     * @param {Object} field
     * @returns {Boolean}
     */
    selectIsClearable(field) {
      if (field.input_type === "select") {
        return !field.required;
      } else return false;
    },

    /**
     * @returns - minNumberHPsPerMDU from network Rules
     */
    async getNetworkRuleMDU() {
      try {
        let workspace = await this.FETCH_ALL_NETWORK_RULES_TEMPLATES({
          type: "id",
          value: sessionStorage.getItem("workspace_rules_id")
        });
        this.minNumberHPsPerMDU = workspace.data[0].data.mdu_classifier;
      } catch (error) {
        console.error(error);
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/multiSelectionMixin.js